<script>
  import {
    FormTheme,
    Toast,
    Callout,
    Loader,
    Icon,
    Button,
  } from "@gl/design-system";
  import Portal from "svelte-portal";
  import { _ } from "../stores/index";
  import { faRedo } from "@fortawesome/pro-regular-svg-icons";
  import { onMount } from "svelte";

  let toast;

  onMount(() => {
    toast.open();
  });
</script>

<Portal target="body" role="status">
  <Toast bind:this={toast}>
    <Callout status="warning" centered>
      <div class="color-warning">
        <Icon icon={faRedo} />
        <b> {$_("home.refresh.version")}</b>

        <Button
          class="p-0"
          sty
          transparent
          on:click={() => {
            toast.close();
            location.reload();
            return false;
          }}
        >
          {$_("home.refresh.version.click")}
        </Button>
      </div>
    </Callout>
  </Toast>
</Portal>
